import type { ReactElement } from 'react'
import DocViewer, { DocViewerRenderers } from 'react-doc-viewer'
import { viewerDocument } from './PublicShortlist.css'

type ShortlistDocumentPreviewProps = {
  url: string
}

export const ShortlistDocumentPreview = ({
  url
}: ShortlistDocumentPreviewProps): ReactElement => (
  <DocViewer
    className={viewerDocument}
    documents={[{ uri: url }]}
    pluginRenderers={DocViewerRenderers}
    config={{
      header: {
        disableHeader: true,
        disableFileName: true
      }
    }}
  />
)
